<template>
  <div class="opc-layout" id="the-main-content">
    <!-- 
      When `showIAPRedirectLoading` is true, we show a loading screen as the initial view 
      instead of the regular skeleton UI. 
      This is based on design requirements and only applies to the "in-app purchase" scenario 
      when the user is redirected from the native app client.
    -->
    <div v-if="showIAPRedirectLoading" class="opc-layout__redirect_loading_layer">
      <p>{{ $t('billing.redirected_to') }}<br/>{{ locationDomain }}</p>
      <img :src="LoadingSpikes" />
    </div>
    <template v-else>
      <div class="opc-layout__layer" role="complementary">
        <div class="opc-layout__layer__inner">
          <drawer :scroll-to-top="true">
            <slot name="side"></slot>
            <total slot="head" />
          </drawer>
        </div>
      </div>
      <div class="opc-layout__main" role="main">
        <div class="opc-layout__main__inner">
          <template v-if="globalErrorState">
            <error-config />
          </template>
          <template v-else>
            <slot></slot>
            <div class="opc-layout__action">
              <div class="opc-layout__action__inner">
                <slot name="action"></slot>
              </div>
            </div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Drawer from './drawer.vue';
import Total from '@/views/config/shopping-cart/total.m.vue';
import ErrorConfig from '@/components/error/config';
import { mapGetters } from 'vuex';
import { iapLoadingLayerMixin } from '@/utils/iap.js';

export default {
  name: 'viewLayoutMobile',
  mixins: [iapLoadingLayerMixin()],
  components: {
    ErrorConfig,
    Drawer,
    Total,
  },
  computed: {
    ...mapGetters(["globalErrorState"])
  },
  created() {
    try {
      [...document?.querySelectorAll('html,body')].forEach((x) => (x.style.background = 'white'));
    } catch (e) {
      console.log(e);
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@zoom/billing-responsive/styles/responsive.scss';
@import '@/styles/_variables.scss';
@import '@/styles/iap.scss';

$bleeding-top: 50PX;
$space: 24PX;
$layer-height: 50PX;
.opc-layout {
  width: 100%;
  position: relative;
  z-index: 0;
  padding-top: $bleeding-top;
  padding-top: 0PX;
  @include media(mobile,tablet){
    padding-top: $bleeding-top;
  }
  &__layer {
    position: relative;
    &__inner {
      position: fixed;
      z-index: 110;
      width: 100%;
      padding-top: 0PX;
      background: #f7f7f8;
      @supports (backdrop-filter: blur()){
        background: rgba(240, 240, 240, 0.5);
        backdrop-filter: blur(24PX);
      }
      border-top: 1PX solid #e0e0e6;
      border-bottom: 1PX solid #e0e0e6;
      height: $layer-height;

      /deep/ .opc-drawer__head {
        .zm-button>span+[class*=zm-icon-] {
          margin-left: 4PX;
        }
      }
    }
  }
  &__main {
    overflow-y: auto;
    // height: calc(100vh - #{$bleeding-top});
    // height: calc(100dvh - #{$bleeding-top}); // for ios toolbar height
    height: auto;
    background: white;
    padding: $space;
    padding-top: $space + $layer-height;
    // padding-bottom: $layer-height + 44PX;
    @include media(tablet, desktop){
      max-width: $tablet-inner-width;
      margin: 0 auto;
    }
    @include media(mobile) {
      padding-left: 16PX;
      padding-right: 16PX;
    }
    &__inner {
    }
  }
  &__action {
    margin-top: $space * 2;
    &__inner {
      text-align: center;
    }
  }
}
</style>
